// extracted by mini-css-extract-plugin
module.exports = {"root":"payments_root__3ecJY","list":"payments_list__1nyjQ","title":"payments_title__3Zadl","addNew":"payments_addNew__bL25U"};